import styled from 'styled-components';

export const AvatarStyle = styled.div(({ theme }) => {
  return `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 100%;
    background: ${theme.colors.commentsAvatarBg};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    font-size: 12px;
    color: white;
    font-weight: bold;
    outline: 5px solid ${theme.colors.commentsBg};

    ${theme.mediaQueries.desktop} {
      width: 58px;
      height: 58px;
      font-size: 16px;
      outline-width: 10px;
    }

    
  `;
});
